var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("onboarding-section", {
    attrs: { "animate-leave": _vm.animateLeave },
    scopedSlots: _vm._u([
      {
        key: "right",
        fn: function () {
          return [
            _c(
              "div",
              { class: _vm.$style.right__wrapper },
              [
                _c(
                  "div",
                  {
                    class: [
                      _vm.$style.select__wrapper,
                      _vm.animateEnter && !_vm.animateLeave
                        ? _vm.$style.animateEnter
                        : "",
                      _vm.animateLeave && !_vm.animateEnter
                        ? _vm.$style.animateLeave
                        : "",
                    ],
                  },
                  _vm._l(_vm.plansItems, function (item) {
                    return _c(
                      "div",
                      {
                        key: item.value,
                        class: _vm.$style.item__wrapper,
                        attrs: {
                          id:
                            "gp_autotest_registration_3_step_selectItem_" +
                            item.value,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleClick(item.value)
                          },
                        },
                      },
                      [
                        _c("span", { class: _vm.$style.item__text }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(item.label) +
                              "\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { class: _vm.$style.icon__wrap },
                          [
                            _c(
                              "vgpSvgImage",
                              _vm._b(
                                { class: _vm.$style.item__icon },
                                "vgpSvgImage",
                                item.iconConfig,
                                false
                              )
                            ),
                          ],
                          1
                        ),
                      ]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _c(
                  "portal",
                  { attrs: { to: "onboarding-footer" } },
                  [
                    _c("vgp-button", {
                      class: [
                        _vm.$style.submit_button,
                        _vm.animateEnter && !_vm.animateLeave
                          ? _vm.$style.animateEnter
                          : "",
                        _vm.animateLeave && !_vm.animateEnter
                          ? _vm.$style.animateLeave
                          : "",
                      ],
                      attrs: {
                        id: "gp_autotest_registration_3_step_submit_button",
                        type: "text-green",
                        label: _vm.locales("onboarding_skip_step_btn_label"),
                        small: "",
                      },
                      on: {
                        onClick: function ($event) {
                          return _vm.nextStep(true)
                        },
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }